import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnInit {
  @Input()
  totalItems: number;

  @Input()
  limit = 18;

  @Input()
  label = 'apps';

  @Output()
  updatePageClick: EventEmitter<number> = new EventEmitter<number>();

  currentIndex = 0;
  lastIndex = 18;
  currentPage = 0;

  constructor() {}

  ngOnInit(): void {
    this.lastIndex =
      this.totalItems > this.limit ? this.limit : this.totalItems;
  }

  calculateIndexes() {
    this.currentIndex = this.currentPage * this.limit;
    this.lastIndex = this.currentIndex + this.limit;
    if (this.lastIndex > this.totalItems) {
      this.lastIndex = this.totalItems;
    }
  }

  nextPage() {
    const maxPage = this.totalItems / this.limit;
    if (this.currentPage < maxPage - 1) {
      ++this.currentPage;
      this.calculateIndexes();
      this.updatePageClick.emit(this.currentIndex);
    }
  }

  prevPage() {
    if (this.currentPage > 0) {
      --this.currentPage;
      this.calculateIndexes();
      this.updatePageClick.emit(this.currentIndex);
    }
  }
}
